export default __webpack_public_path__ + "assets/images/889c09cfd33bbf95c698759a902905a9.svg";